import React, { ReactElement } from "react";
import { useForm } from "../hooks/useForm";
import { Classes } from "@components/shared/form";
import { BuyersList } from "@components/shared/form/buyersList";
import styles from "@components/shared/form/styles.module.scss";

type UseFormReturn = ReturnType<typeof useForm>;

interface BuyersListStepProps {
    operation: UseFormReturn["operation"];
    dispatch: UseFormReturn["dispatch"];
    submitButtonText: string | undefined;
    isLoading: boolean;
    startSecondRoundBidding: UseFormReturn["startSecondRoundBidding"];
    classes?: Classes;
}

export default function BuyersListStep({
    operation,
    dispatch,
    submitButtonText,
    isLoading,
    startSecondRoundBidding,
    classes,
}: BuyersListStepProps): ReactElement {
    return (
        <div className={styles["step"]}>
            <div>
                <div className={styles["extra-step-inner"]}>
                    {operation?.key === "ROUND_TWO" && (
                        <BuyersList
                            dispatch={dispatch}
                            operation={operation}
                            buttonText={submitButtonText}
                            isLoading={isLoading}
                            handleSubmit={startSecondRoundBidding}
                            buttonClassName={classes?.formButtonClassName}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
